<template>
  <div id="skills_container">
    <div id="skills">
      <div class="cards" v-for="card in disp_cards" :key="card.id">
        <img class="card_img" :src="card.image" />
        <div class="card_title">
          {{ card.title }}
        </div>
        <div class="card_description">
          {{ card.description }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      disp_cards: [],
      cards: [
        {
          title: "Vim",
          description: "Skill Description",
          image: require("../assets/vim.svg"),
        },
      ],
    };
  },
  created() {
    this.UpdateCards();
  },
  methods: {
    UpdateCards() {
      this.disp_cards = this.cards;
    },
  },
};
</script>

<style lang="scss" scoped>
#skills_container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: "メイリオ", sans-serif;

  #skills {
    width: 80%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;

    .card {
      width: 250px;
      height: 300px;
      border-radius: 10px;
      box-shadow: 0px 2px 8px -4px #777777;
      margin: 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;

      .card_img {
        width: 100px;
        height: 250px;
        border-radius: 10px 10px 0 0;
      }

      .card_description {
        background-color: #fff;
        width: 100px;
        height: 250px;
        padding: 10px;
        margin-bottom: 50px;
        font-size: 15px;
        font-weight: 900;
        position: absolute;
        opacity: 0;
        transition: 0.3s;

        &:hover {
          opacity: 1;
          background-size: rgba($color: #fff, $alpha: 0.9);
        }
      }

      .card_title {
        width: 100%;
        height: 50px;
        font-size: 17px;
        font-weight: 900;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
</style>
